// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reportes-container {
  padding: 24px;
  animation: fadeIn 0.4s ease-in-out;
}

.reportes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.reportes-header h2 {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.export-actions {
  display: flex;
  gap: 12px;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.kpi-card {
  background: var(--bg-card);
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease;
}

.kpi-card:hover {
  transform: translateY(-2px);
}

.kpi-title {
  font-size: 14px;
  color: var(--text-muted);
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.kpi-value {
  font-size: 28px;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 4px;
}

.kpi-subtitle {
  font-size: 13px;
  color: var(--text-muted);
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 24px;
  margin-bottom: 30px;
}

.chart-card {
  background: var(--bg-card);
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  height: 400px;
}

.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-color);
  margin-bottom: 20px;
}

.tables-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.table-card {
  background: var(--bg-card);
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border: 1px solid var(--border);
  overflow-x: auto;
}

.table-card h3 {
  font-size: 18px;
  margin-bottom: 16px;
  color: var(--text-color);
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

.report-table th, .report-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid var(--border);
}

.report-table th {
  font-weight: 600;
  color: var(--text-muted);
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: rgba(0,0,0,0.02);
}

.report-table td {
  font-size: 14px;
  color: var(--text-color);
}



.report-table tbody tr:hover {
  background: rgba(0,0,0,0.01);
}

.status-indicator {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.status-solvent {
  background: rgba(34, 197, 94, 0.1);
  color: #16a34a;
}

.status-debt {
  background: rgba(239, 68, 68, 0.1);
  color: #dc2626;
}

.status-neutral {
  background: rgba(107, 114, 128, 0.1);
  color: #4b5563;
}

@media (max-width: 768px) {
  .reportes-container {
    padding: 16px;
  }
  
  .reportes-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .export-actions {
    width: 100%;
    flex-direction: column;
  }
  
  .export-actions button {
    width: 100%;
  }
  
  .charts-grid {
    grid-template-columns: 1fr;
  }
  
  .chart-card {
    height: auto;
    min-height: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ReportesProveedores.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;;;AAIA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".reportes-container {\n  padding: 24px;\n  animation: fadeIn 0.4s ease-in-out;\n}\n\n.reportes-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.reportes-header h2 {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-color);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.export-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.kpi-card {\n  background: var(--bg-card);\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.05);\n  border: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s ease;\n}\n\n.kpi-card:hover {\n  transform: translateY(-2px);\n}\n\n.kpi-title {\n  font-size: 14px;\n  color: var(--text-muted);\n  font-weight: 600;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.kpi-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--primary-color);\n  margin-bottom: 4px;\n}\n\n.kpi-subtitle {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.charts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 24px;\n  margin-bottom: 30px;\n}\n\n.chart-card {\n  background: var(--bg-card);\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.05);\n  border: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  height: 400px;\n}\n\n.chart-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-color);\n  margin-bottom: 20px;\n}\n\n.tables-section {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.table-card {\n  background: var(--bg-card);\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.05);\n  border: 1px solid var(--border);\n  overflow-x: auto;\n}\n\n.table-card h3 {\n  font-size: 18px;\n  margin-bottom: 16px;\n  color: var(--text-color);\n}\n\n.report-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 600px;\n}\n\n.report-table th, .report-table td {\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 1px solid var(--border);\n}\n\n.report-table th {\n  font-weight: 600;\n  color: var(--text-muted);\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  background: rgba(0,0,0,0.02);\n}\n\n.report-table td {\n  font-size: 14px;\n  color: var(--text-color);\n}\n\n\n\n.report-table tbody tr:hover {\n  background: rgba(0,0,0,0.01);\n}\n\n.status-indicator {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.status-solvent {\n  background: rgba(34, 197, 94, 0.1);\n  color: #16a34a;\n}\n\n.status-debt {\n  background: rgba(239, 68, 68, 0.1);\n  color: #dc2626;\n}\n\n.status-neutral {\n  background: rgba(107, 114, 128, 0.1);\n  color: #4b5563;\n}\n\n@media (max-width: 768px) {\n  .reportes-container {\n    padding: 16px;\n  }\n  \n  .reportes-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .export-actions {\n    width: 100%;\n    flex-direction: column;\n  }\n  \n  .export-actions button {\n    width: 100%;\n  }\n  \n  .charts-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .chart-card {\n    height: auto;\n    min-height: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
